var map = {
	"./ad.svg": 23087,
	"./ae.svg": 60510,
	"./af.svg": 72605,
	"./ag.svg": 44060,
	"./ai.svg": 4330,
	"./al.svg": 86183,
	"./am.svg": 46646,
	"./ao.svg": 14676,
	"./aq.svg": 62818,
	"./ar.svg": 43217,
	"./arab.svg": 86396,
	"./as.svg": 86304,
	"./asean.svg": 61500,
	"./at.svg": 15679,
	"./au.svg": 61390,
	"./aw.svg": 36652,
	"./ax.svg": 51627,
	"./az.svg": 71945,
	"./ba.svg": 10207,
	"./bb.svg": 38508,
	"./bd.svg": 59906,
	"./be.svg": 22547,
	"./bf.svg": 51648,
	"./bg.svg": 14449,
	"./bh.svg": 39590,
	"./bi.svg": 27127,
	"./bj.svg": 84004,
	"./bl.svg": 27098,
	"./bm.svg": 46155,
	"./bn.svg": 7320,
	"./bo.svg": 42185,
	"./bq.svg": 68591,
	"./br.svg": 89564,
	"./bs.svg": 43837,
	"./bt.svg": 9906,
	"./bv.svg": 2704,
	"./bw.svg": 14945,
	"./by.svg": 79271,
	"./bz.svg": 7764,
	"./ca.svg": 7048,
	"./cc.svg": 70570,
	"./cd.svg": 80981,
	"./cefta.svg": 15103,
	"./cf.svg": 26855,
	"./cg.svg": 39734,
	"./ch.svg": 62529,
	"./ci.svg": 50288,
	"./ck.svg": 57490,
	"./cl.svg": 91421,
	"./cm.svg": 37148,
	"./cn.svg": 99823,
	"./co.svg": 37246,
	"./cp.svg": 89769,
	"./cr.svg": 93739,
	"./cu.svg": 31588,
	"./cv.svg": 74711,
	"./cw.svg": 87174,
	"./cx.svg": 62033,
	"./cy.svg": 99232,
	"./cz.svg": 70131,
	"./de.svg": 61001,
	"./dg.svg": 93707,
	"./dj.svg": 31214,
	"./dk.svg": 45855,
	"./dm.svg": 42769,
	"./do.svg": 89395,
	"./dz.svg": 25886,
	"./eac.svg": 78937,
	"./ec.svg": 32084,
	"./ee.svg": 40970,
	"./eg.svg": 77896,
	"./eh.svg": 9871,
	"./er.svg": 70949,
	"./es-ct.svg": 95844,
	"./es-ga.svg": 21645,
	"./es-pv.svg": 86895,
	"./es.svg": 73700,
	"./et.svg": 41291,
	"./eu.svg": 63770,
	"./fi.svg": 30491,
	"./fj.svg": 96104,
	"./fk.svg": 61497,
	"./fm.svg": 68935,
	"./fo.svg": 93333,
	"./fr.svg": 38432,
	"./ga.svg": 79404,
	"./gb-eng.svg": 96388,
	"./gb-nir.svg": 25139,
	"./gb-sct.svg": 11618,
	"./gb-wls.svg": 85712,
	"./gb.svg": 58431,
	"./gd.svg": 85969,
	"./ge.svg": 29056,
	"./gf.svg": 36147,
	"./gg.svg": 5570,
	"./gh.svg": 24037,
	"./gi.svg": 46020,
	"./gl.svg": 14697,
	"./gm.svg": 55544,
	"./gn.svg": 94379,
	"./gp.svg": 15357,
	"./gq.svg": 86812,
	"./gr.svg": 65839,
	"./gs.svg": 3262,
	"./gt.svg": 63169,
	"./gu.svg": 48368,
	"./gw.svg": 81426,
	"./gy.svg": 57428,
	"./hk.svg": 62051,
	"./hm.svg": 62941,
	"./hn.svg": 50846,
	"./hr.svg": 36698,
	"./ht.svg": 93604,
	"./hu.svg": 71621,
	"./ic.svg": 97656,
	"./id.svg": 17463,
	"./ie.svg": 29926,
	"./il.svg": 543,
	"./im.svg": 79438,
	"./in.svg": 8557,
	"./io.svg": 28844,
	"./iq.svg": 13322,
	"./ir.svg": 57721,
	"./is.svg": 49800,
	"./it.svg": 69607,
	"./je.svg": 78747,
	"./jm.svg": 85763,
	"./jo.svg": 52865,
	"./jp.svg": 77510,
	"./ke.svg": 50300,
	"./kg.svg": 16222,
	"./kh.svg": 33017,
	"./ki.svg": 20648,
	"./km.svg": 74836,
	"./kn.svg": 23047,
	"./kp.svg": 33105,
	"./kr.svg": 79731,
	"./kw.svg": 21550,
	"./ky.svg": 25976,
	"./kz.svg": 84043,
	"./la.svg": 66989,
	"./lb.svg": 18638,
	"./lc.svg": 47071,
	"./li.svg": 41413,
	"./lk.svg": 17015,
	"./lr.svg": 61726,
	"./ls.svg": 5455,
	"./lt.svg": 39568,
	"./lu.svg": 75105,
	"./lv.svg": 81970,
	"./ly.svg": 36085,
	"./ma.svg": 9310,
	"./mc.svg": 74012,
	"./md.svg": 44195,
	"./me.svg": 13202,
	"./mf.svg": 22689,
	"./mg.svg": 87152,
	"./mh.svg": 59271,
	"./mk.svg": 11060,
	"./ml.svg": 20827,
	"./mm.svg": 60458,
	"./mn.svg": 51833,
	"./mo.svg": 86440,
	"./mp.svg": 94655,
	"./mq.svg": 66222,
	"./mr.svg": 14573,
	"./ms.svg": 15628,
	"./mt.svg": 49523,
	"./mu.svg": 28002,
	"./mv.svg": 64721,
	"./mw.svg": 28768,
	"./mx.svg": 64599,
	"./my.svg": 66566,
	"./mz.svg": 88997,
	"./na.svg": 84715,
	"./nc.svg": 5033,
	"./ne.svg": 40951,
	"./nf.svg": 36356,
	"./ng.svg": 14373,
	"./ni.svg": 26483,
	"./nl.svg": 94478,
	"./no.svg": 5197,
	"./np.svg": 37418,
	"./nr.svg": 98024,
	"./nu.svg": 35623,
	"./nz.svg": 38704,
	"./om.svg": 86288,
	"./pa.svg": 95617,
	"./pc.svg": 28515,
	"./pe.svg": 24509,
	"./pf.svg": 70334,
	"./pg.svg": 49263,
	"./ph.svg": 40136,
	"./pk.svg": 21499,
	"./pl.svg": 88436,
	"./pm.svg": 14069,
	"./pn.svg": 72822,
	"./pr.svg": 40578,
	"./ps.svg": 3219,
	"./pt.svg": 19180,
	"./pw.svg": 90879,
	"./py.svg": 22857,
	"./qa.svg": 35106,
	"./re.svg": 22211,
	"./ro.svg": 23353,
	"./rs.svg": 11213,
	"./ru.svg": 70067,
	"./rw.svg": 23441,
	"./sa.svg": 34520,
	"./sb.svg": 85259,
	"./sc.svg": 54298,
	"./sd.svg": 31749,
	"./se.svg": 80580,
	"./sg.svg": 9318,
	"./sh-ac.svg": 86018,
	"./sh-hl.svg": 79498,
	"./sh-ta.svg": 55531,
	"./sh.svg": 7473,
	"./si.svg": 71520,
	"./sj.svg": 92275,
	"./sk.svg": 87106,
	"./sl.svg": 57325,
	"./sm.svg": 58380,
	"./sn.svg": 37407,
	"./so.svg": 8974,
	"./sr.svg": 63579,
	"./ss.svg": 3210,
	"./st.svg": 26421,
	"./sv.svg": 2023,
	"./sx.svg": 65441,
	"./sy.svg": 29904,
	"./sz.svg": 86947,
	"./tc.svg": 49607,
	"./td.svg": 76776,
	"./tf.svg": 50794,
	"./tg.svg": 11163,
	"./th.svg": 64348,
	"./tj.svg": 99646,
	"./tk.svg": 27023,
	"./tl.svg": 77488,
	"./tm.svg": 13025,
	"./tn.svg": 3538,
	"./to.svg": 34531,
	"./tr.svg": 56902,
	"./tt.svg": 82104,
	"./tv.svg": 1882,
	"./tw.svg": 32843,
	"./tz.svg": 56558,
	"./ua.svg": 68486,
	"./ug.svg": 36216,
	"./um.svg": 86242,
	"./un.svg": 66641,
	"./us.svg": 38100,
	"./uy.svg": 83934,
	"./uz.svg": 96029,
	"./va.svg": 45971,
	"./vc.svg": 37873,
	"./ve.svg": 33631,
	"./vg.svg": 41645,
	"./vi.svg": 69579,
	"./vn.svg": 7428,
	"./vu.svg": 92015,
	"./wf.svg": 18851,
	"./ws.svg": 60110,
	"./xk.svg": 12819,
	"./xx.svg": 75568,
	"./ye.svg": 56854,
	"./yt.svg": 51575,
	"./za.svg": 97687,
	"./zm.svg": 82611,
	"./zw.svg": 84921
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60612;